import { render, staticRenderFns } from "./ContentNumeric.vue?vue&type=template&id=4fb2199c"
import script from "./ContentNumeric.vue?vue&type=script&lang=js"
export * from "./ContentNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports